import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const pageTitles: Record<string, string> = {
  '/oauth/callback': 'Bank Sheets - Connecting',
  '/v1/signin': 'Bank Sheets - Sign In',
  '/v1/billing': 'Bank Sheets - Billing',
  '/v1/billing/success': 'Bank Sheets - Billing',
  '/v1/billing/cancel': 'Bank Sheets - Billing',
  '/v1/settings': 'Bank Sheets - Settings',
  '/v1/account-settings': 'Bank Sheets - Settings',
  '/v1/onboarding/welcome': 'Bank Sheets - Welcome',
  '/v1/onboarding/connect-bank-intro': 'Bank Sheets - Connect Bank',
  '/v1/onboarding/select-card': 'Bank Sheets - Choose Accounts',
  '/v1/onboarding/nick-names-info': 'Bank Sheets - Account Names',
  '/v1/onboarding/add-nick-names': 'Bank Sheets - Account Names',
  '/v1/onboarding/sync-transaction-info': 'Bank Sheets - Transaction Sync',
  '/v1/onboarding/select-sync-date': 'Bank Sheets - Transaction History',
  '/v1/onboarding/connect-new-bank': 'Bank Sheets - Connect Bank',
  '/v1/onboarding/select-template': 'Bank Sheets - Choose Template',
  '/v1/app/dashboard': 'Bank Sheets - Dashboard',
}

export const getPageTitle = (pathname: string): string => pageTitles[pathname] || 'Bank Sheets'

export const PageTitle = () => {
  const location = useLocation()

  useEffect(() => {
    document.title = getPageTitle(location.pathname)
  }, [location])

  return null
}
